import styled from 'styled-components'
import { colors, fontScope } from '../../../components/SalesReport/tokens'

export * from '../../SalesReport/FiltersPanel/styles'

export const ClearLink = styled.button`
  margin-left: auto;
  padding: 4px 0;
  border: 0;
  background: transparent;
  font-size: 13px;
  font-weight: 600;
  color: ${colors.primaryStrong};
  cursor: pointer;
  white-space: nowrap;

  &:focus-visible {
    outline: 2px solid ${colors.primary};
    outline-offset: 2px;
  }
`

export const MobileDisplay = styled.div`
  ${fontScope}
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 12px;
  border: 1px solid ${colors.border};
  border-radius: 12px;
  background: ${colors.white};
`

export const MobileInline = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
`
